// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import { withTheme } from 'styled-components';
import { SNJ_HP_PRIMARY_FILL } from '@tcp/core/src/constants/brandSpecific.constants';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import GetCandidSkeleton from '@tcp/core/src/components/common/molecules/GetCandid/views/GetCandidSkeleton';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { requireNamedOnlineModule } from '../../../../../utils/resourceLoader';
import style from '../styles/GetCandid.style';
import withStyles from '../../../hoc/withStyles';
import {
  getAPIConfig,
  routerPush,
  getViewportInfo,
  getBrand,
  isGymboree,
  getBrandInCaps,
} from '../../../../../utils';
import withLazyLoad from '../../../hoc/withLazyLoad';
import {
  GLOBAL_GETCANDID_LABELS,
  globalGetCandidLabelsCopy,
  dynamicGetCandidTitleLabel,
} from '../labels/GetCandid.labels';

import config from '../config';

const { carouselConfig } = config;

class GetCandid extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    productId: PropTypes.string,
    theme: PropTypes.shape({}).isRequired,
    isHomePage: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    productId: '',
    isHomePage: false,
  };

  candidConfig = getAPIConfig();

  constructor(props) {
    super(props);
    this.state = {
      getCandidDataLoaded: false,
    };
    this.globalGetCandidLabels = getLabelFromCopyOrFromTranslation(
      GLOBAL_GETCANDID_LABELS,
      globalGetCandidLabelsCopy
    );
  }

  componentDidMount() {
    const {
      theme: {
        breakpoints: { maxWidth: maxViewportWidth },
      },
      productId,
    } = this.props;
    const { isDesktop, isTablet, width } = getViewportInfo();
    let candidViewportSetting = carouselConfig.mobile;

    if (isTablet) {
      candidViewportSetting = carouselConfig.tablet;
    } else if (isDesktop) {
      candidViewportSetting = carouselConfig.desktop;
    }

    if (width >= maxViewportWidth) {
      candidViewportSetting = carouselConfig.largeDesktop;
    }

    const candidSlot = 'tcp-get-candid-image-container';
    const apiKey = this.candidConfig.CANDID_API_KEY;
    const tagKey = productId;
    requireNamedOnlineModule('getCandid').then(() => {
      const obj = {
        id: apiKey,
        containerId: candidSlot,
        cluster: `${
          isGymboree()
            ? '5cb4b8a5c9e77c0001cf88c5-7190B10B8BE150479D2C9A8C06691AFC31E4A56B17E8504303D09529246720AEE833EF6522D0F54343BDA0A0B961156E3A094990D0980C3217A00C61E28835D6F62D31022C064EFFD359E772A055965011A8D459972A0CA811F419C91653BDEE'
            : 'prod-2'
        }`,

        useDescription: false,
        ...candidViewportSetting,
        ready: () => this.setState({ getCandidDataLoaded: true }),
      };
      if (tagKey) {
        obj.tag = tagKey;
      }
      window.candid.init(obj);
    });
  }

  handleUpload = () => {
    if (window.candid) {
      window.candid.upload(this.candidConfig.CANDID_API_KEY, [], this.candidConfig.CANDID_API_URL);
    }
  };

  handleViewGalleryClick = () => {
    routerPush('/content?contentType=mystyleplace', '/content/mystyleplace');
  };

  getDefaultHeading = () => {
    return (
      <div className="get-candid-default-heading">
        <BodyCopy
          component="h2"
          fontWeight="medium"
          fontSize={['fs20', 'fs20', 'fs32']}
          textAlign="center"
          className="get-candid-main-heading"
          data-locator="get_candid_module_header_textImages_1"
        >
          {dynamicGetCandidTitleLabel}
        </BodyCopy>

        <BodyCopy
          fontSize={['fs16', 'fs16', 'fs26']}
          textAlign="center"
          className="get-candid-heading-desc"
          data-locator="get_candid_module_header_textImages_2"
        >
          {renderLabel(
            this.globalGetCandidLabels.lbl_getCandid_titleDescription,
            'lbl_getCandid_titleDescription'
          )}
        </BodyCopy>
      </div>
    );
  };

  render() {
    const { className, isHomePage } = this.props;
    const { getCandidDataLoaded } = this.state;
    const hideOnLoadingClassName = getCandidDataLoaded ? '' : 'hide';
    /*
       Carousel does not render correctly if we display:none whole component
       on no data. Using this to fix unnecessary height on flex element.
    */
    const noFlexClassName = getCandidDataLoaded ? '' : 'no-flex';

    return (
      <section id="get-candid-container" className={`${className} brand-${getBrand()}`}>
        <div className={isHomePage ? 'min-height-candid' : ''}>
          <Row className={hideOnLoadingClassName} centered>
            <Col
              colSize={{
                small: 6,
                medium: 8,
                large: 12,
              }}
            >
              {this.getDefaultHeading()}
            </Col>
          </Row>

          <Row className={noFlexClassName} centered>
            <Col
              colSize={{
                small: 6,
                medium: 8,
                large: 12,
              }}
              className={noFlexClassName}
            >
              <div id="tcp-get-candid-image-container" />
            </Col>
          </Row>
          <Row className={hideOnLoadingClassName} centered>
            <div className="get-candid-button-container">
              <Col
                colSize={{
                  small: 6,
                  medium: 8,
                  large: 12,
                }}
              >
                <Button
                  onClick={this.handleViewGalleryClick}
                  buttonVariation="fixed-width"
                  className="gallery-button-left"
                  data-locator="view_gallery_button"
                  fill={SNJ_HP_PRIMARY_FILL[`${getBrandInCaps()}`]}
                >
                  <span>
                    {renderLabel(
                      this.globalGetCandidLabels?.lbl_getCandid_BtnGallery,
                      'lbl_getCandid_BtnGallery'
                    )}
                  </span>
                </Button>

                <Button
                  onClick={this.handleUpload}
                  buttonVariation="fixed-width"
                  className="gellary-button-right"
                  data-locator="add_photo_button"
                  fill={SNJ_HP_PRIMARY_FILL[`${getBrandInCaps()}`]}
                >
                  <span>
                    {renderLabel(
                      this.globalGetCandidLabels?.lbl_getCandid_BtnPhoto,
                      'lbl_getCandid_BtnPhoto'
                    )}
                  </span>
                </Button>
              </Col>
            </div>
          </Row>
        </div>
      </section>
    );
  }
}

const lazyLoadConfig = {
  placeholder: <GetCandidSkeleton />,
};
GetCandid.lazyLoadConfig = lazyLoadConfig;
export default withStyles(withLazyLoad(withTheme(GetCandid)), style);
export { GetCandid as GetCandidVanilla };
